import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import LangGate from "@/components/LangGate";

import Home from "@/pages/Home";
import Platforma from "@/pages/Platforma";
import PMS from "@/pages/PMS";
import BookingEngine from "@/pages/BookingEngine";
import ChannelManager from "@/pages/ChannelManager";
import Housekeeping from "@/pages/Housekeeping";
import POS from "@/pages/POS";
import RevenueManagement from "@/pages/RevenueManagement";
import Integrimet from "@/pages/Integrimet";
import Cmimet from "@/pages/Cmimet";
import Kontakt from "@/pages/Kontakt";
import Demo from "@/pages/Demo";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AdminEditor from "@/pages/AdminEditor";
import NotFound from "@/pages/NotFound";
import RrethNesh from "@/pages/RrethNesh";
import Download from "@/pages/Download";

// Public routes mounted under both `/` (SQ, default) and `/en/` (English).
// LangGate reads the URL prefix and updates the I18n context accordingly,
// so each language version is a distinct URL that Google can index.
const publicRoutes = [
  { path: "", element: <Home /> },
  { path: "platforma", element: <Platforma /> },
  { path: "pms", element: <PMS /> },
  { path: "booking-engine", element: <BookingEngine /> },
  { path: "channel-manager", element: <ChannelManager /> },
  { path: "housekeeping", element: <Housekeeping /> },
  { path: "pos", element: <POS /> },
  { path: "revenue-management", element: <RevenueManagement /> },
  { path: "integrimet", element: <Integrimet /> },
  { path: "cmimet", element: <Cmimet /> },
  { path: "kontakt", element: <Kontakt /> },
  { path: "rreth-nesh", element: <RrethNesh /> },
  { path: "demo", element: <Demo /> },
  { path: "desktop", element: <Download /> },
  { path: "blog", element: <Blog /> },
  { path: "blog/:slug", element: <BlogPost /> },
];

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <Routes>
              <Route element={<Layout />}>
                {/* Default (Albanian) tree */}
                <Route element={<LangGate lang="sq" />}>
                  {publicRoutes.map((r) => (
                    <Route key={`sq-${r.path}`} path={r.path === "" ? "/" : `/${r.path}`} element={r.element} />
                  ))}
                </Route>

                {/* English tree — /en/* — separate URLs indexed by Google */}
                <Route element={<LangGate lang="en" />}>
                  <Route path="/en" element={<Home />} />
                  {publicRoutes.slice(1).map((r) => (
                    <Route key={`en-${r.path}`} path={`/en/${r.path}`} element={r.element} />
                  ))}
                </Route>

                {/* Legacy language aliases (redirect any /it, /de, /fr, /sq back home) */}
                <Route path="/it" element={<LangGate lang="sq" fallback="/" />} />
                <Route path="/de" element={<LangGate lang="sq" fallback="/" />} />
                <Route path="/fr" element={<LangGate lang="sq" fallback="/" />} />
                <Route path="/sq" element={<LangGate lang="sq" fallback="/" />} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                <Route path="/admin/new" element={<ProtectedRoute><AdminEditor /></ProtectedRoute>} />
                <Route path="/admin/edit/:id" element={<ProtectedRoute><AdminEditor /></ProtectedRoute>} />

                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
